import User from "../singleton/user";

export default {

    getOtherApplications: User.getOtherApplications.bind(User),

    getApplications: User.getApplications.bind(User),

    getName: User.getName.bind(User),

    changePassword: User.changePassword.bind(User),

    setCallUrl: User.setCallUrl.bind(User),

    getCallUrl: User.getCallUrl.bind(User),

    hasTableAccess: User.hasTableAccess.bind(User),

    hasModuleAccess: User.hasModuleAccess.bind(User),

    isAdmin: User.isAdmin.bind(User),

    isDesigner: User.isDesigner.bind(User),

    isDelete: User.isDelete.bind(User),

    isWrite: User.isWrite.bind(User),

    getPermissions: User.getPermissions.bind(User),

    getImage: User.getImage.bind(User),

    setData: User.setData.bind(User)

}